

import React, { useContext, useState,useRef } from 'react'
import { Skeleton } from 'primereact/skeleton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Card } from 'primereact/card'
import { Divider } from 'primereact/divider';
import { Button } from 'primereact/button';
import profileImage from './../../assets/profileAvatar.png'
import DataContext from '../../context/DataContext';
import { Badge } from 'primereact/badge';
import { useNavigate } from "react-router-dom";
import { capitalizeFirstLetter, formatTIN } from '../../utilities/UtilityFunctions';
import { Password } from 'primereact/password';
import { Dialog } from 'primereact/dialog';
import { Panel } from 'primereact/panel';


        




const UserProfile = () => {
  const { auntheticatedUser } = useContext(DataContext);
  const items = Array.from({ length: 5 }, (v, i) => i);
  const updateSkeletonItems = Array.from({ length: 3 }, (v, i) => i);

  const toast = useRef(null);
  const navigate = useNavigate();

  const [passwordResetModel, setPasswordResetModel] = useState(false);
  const [password,setPassword] = useState("");
  const [passwordInvalid, setPasswordInvalid] = useState("");
  

  const extractTime = () => { 
    const stamp = new Date();
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const dateTime = `${months[stamp.getMonth()]} ${stamp.getFullYear()} `;
    return dateTime;
  }


  const passwordClass=`'w-full mb-0 loginformField' ${passwordInvalid}`

  return (

  <>
    <div className='profilePage'>


      <div className='profileUpperSection'>
        <div className='profiletop'>
        </div>
      
        <div className='profilebottom'>
          <div className='profilebottomLongCard'>

            <div className='flex flex-row  justify-content-between'>
              <div className='mr-4'><img src={profileImage} alt='Profile' width={50} className='border-circle'/></div>
              <div>
                <div className='text-sm font-bold'>{auntheticatedUser?.firstname} {auntheticatedUser?.lastname}</div>
                <div className='text-xs'>Sex: <span className='text-sm font-bold'>{ auntheticatedUser?.sex}</span></div>
                <div>{auntheticatedUser?.role }</div>
              </div>
            </div>

            <div>
              <Button label="Home" severity="secondary" icon="pi pi-home" text className='py-1 px-3' onClick={ (e)=>navigate("/")} />
              <Button label="Submissions" severity="secondary" icon="pi pi-ticket" text className='py-1 px-3' onClick={()=> navigate("/monitorSubmission")}  />
              <Button label="Reset Password" severity="secondary" icon="pi pi-key" text className='py-1 px-3' onClick={()=>setPasswordResetModel(true)}  />
              
            </div>
            
          
          </div>
          <div className='profilebottomCards'>
            <Card className='profileCards w-4 '>
              <p className='text-base font-bold'><i className="pi pi-user" style={{ fontSize: '1rem', marginRight: '0.5rem' }}></i> Profile Information</p>
              
              <p className='text-xs'>TIN: <span className='text-sm font-bold'>{formatTIN(auntheticatedUser?.tin) }</span></p>
              <p className='text-xs'>Mobile: <span className='font-bold' >{auntheticatedUser?.phone}</span></p>
              <p className='text-xs'>Email: <span className='font-bold'>{auntheticatedUser?.email}</span></p>
              <p className='text-xs'>Region: <span className='font-bold'>{capitalizeFirstLetter(auntheticatedUser?.region) }</span></p>
              <p className='text-xs'>District: <span className='font-bold'>{capitalizeFirstLetter(auntheticatedUser?.district) }</span></p>

            </Card>
            <Card className='profileCards w-4'>
              <p className='text-base font-bold flex flex-row justify-content-between'> <span><i className="pi pi-flag" style={{ fontSize: '1rem', marginRight: '0.5rem' }}></i> Status</span> <span className='text-base font-bold'>{ extractTime()}</span></p>
              <div className='flex flex-column h-full'>
                <div className='flex-grow-1'>
                  <div className='flex flex-row justify-content-between align-items-stretch h-full'>
                    <div className='text-center py-5 px-2'><Badge value="ACTIVE" severity="success" className='font-bold'></Badge></div>
                    <div>
                      <div className='text-center py-4 '> <span className='text-base font-bold text-primary '>5 </span> <span className='text-sm'>Submissions</span></div>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
            <Card className='profileCards w-4'> 
              <p className='text-base font-bold'> <i className="pi pi-envelope" style={{ fontSize: '1rem', marginRight: '0.5rem' }}></i> My Follow Up Updates</p>
              <DataTable value={updateSkeletonItems} className="p-datatable-striped">
                <Column field="sn"  style={{ width: '5%' }} body={<Skeleton />}></Column>
                <Column field="update" style={{ width: '35%' }} body={<Skeleton />}></Column>
                <Column field="action" style={{ width: '10%' }} body={<Skeleton />}></Column>
            </DataTable>
          </Card>
       
          </div>
        </div>
      </div>

      
      <div className='mx-6 profileDevider'>
      <Divider align="center" type='solid'  style={{color: "black", width:'100%'}}><span className="p-tag">Latest Submissions</span></Divider>
      </div>
      
      <div className='profileLowerSection'>
        <Card className='mx-6'>
        
        <DataTable value={items} className="p-datatable-striped">
                <Column field="sn" header="SN" style={{ width: '5%' }} body={<Skeleton />}></Column>
                <Column field="incident" header="Incident" style={{ width: '35%' }} body={<Skeleton />}></Column>
                <Column field="status" header="Status" style={{ width: '10%' }} body={<Skeleton />}></Column>
                <Column field="date" header="Date" style={{ width: '10%' }} body={<Skeleton />}></Column>
                <Column field="action" header="Action" style={{ width: '10%' }} body={<Skeleton />}></Column>
            </DataTable>
        </Card>
          
       </div>
        
    </div>

    { passwordResetModel &&
      <Dialog className='-mt-8 mb-4'  visible={passwordResetModel} style={{ width: '20vw' }} onHide={() => setPasswordResetModel(false)} >
        <div className='w-full px-2 mb-4'>
            <label htmlFor="password" className="block text-900 font-medium mb-2">Password</label>
            <Password
              className={passwordClass}
              toggleMask
              feedback={false}
              placeholder='Enter Password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onFocus={() => setPasswordInvalid("")}
              />
          </div >
           <div className='px-2 flex flex-row align-end'>
            <Button
              icon="pi pi-save"
              outlined
              label='Save'
              severity="success"
              aria-label="Save"
              className='px-3 py-1 text-xs mr-2 font-light'
              onClick={() => {
                // getItemtoEdit(rowData);
                // setSelectedId(rowData.id);
                // setEditDialogVisible(true);
              }}
                                        
            />
            </div>
          
     </Dialog>  
  }
 </>
  )
}

export default UserProfile